import './style/PublicNav.css';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import banner from '../images/banner.png';

function PublicNav(props) {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 0);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={`public-nav${scrolled ? ' public-nav--scrolled' : ''}`}>
            {props.showFeatureNav ? (
                <div className='feature-nav'>
                    <a onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}>About</a>
                    <a onClick={() => document.getElementById('modes').scrollIntoView({ behavior: 'smooth' })}>Modes</a>
                    <a onClick={() => document.getElementById('faq').scrollIntoView({ behavior: 'smooth' })}>FAQ</a>
                </div>
            ) : (
                <Link to="/" className='logo'><img src={banner} alt='πPrep' className='nav-banner' /></Link>
            )}
            <div className='links'>
                {props.user ? (
                    <Link to="/arena">Back To Practice</Link>
                ) : (
                    <>
                        <Link to="/signup">Sign Up</Link>
                        <Link to="/login">Log in</Link>
                    </>
                )}
            </div>
        </div>
    );
}

export default PublicNav;
